import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class HideScrollNavService {

  public headerFixed: boolean = false;

}
